var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_IBK 1",
    clipPath: "url(#clip0_1736_9941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#004B9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.80402 5.19784C8.61243 5.29295 8.44169 5.42524 8.30174 5.58701C8.1618 5.74878 8.05546 5.93678 7.98891 6.14006L5.38402 13.9641C5.24771 14.3739 5.27977 14.8211 5.47313 15.2072C5.6665 15.5934 6.00534 15.887 6.41513 16.0234L14.9534 18.8901C15.363 19.025 15.8094 18.9922 16.195 18.799C16.5805 18.6058 16.874 18.2678 17.0111 17.859L19.6149 10.035C19.7507 9.6252 19.7186 9.17834 19.5256 8.7922C19.3327 8.40607 18.9946 8.11213 18.5854 7.97473L10.0471 5.11051C9.84448 5.04195 9.63022 5.01437 9.41681 5.02936C9.2034 5.04435 8.9951 5.10162 8.80402 5.19784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0779 6.05397C12.5717 6.60774 13.6622 8.2033 13.5562 9.94286C13.5186 10.5913 13.3193 11.2199 12.9764 11.7715C12.5061 11.2449 11.9177 10.8372 11.2595 10.5817L10.8779 10.432V14.0609L11.265 13.9106C11.9221 13.6528 12.5085 13.2426 12.9762 12.714C13.4339 13.4477 13.6363 14.3122 13.5519 15.1729C13.4675 16.0336 13.101 16.8422 12.5095 17.4731L12.5133 17.4702L12.5095 17.4746L6.58527 15.4935C6.3169 15.4052 6.09437 15.2143 5.96629 14.9625C5.83821 14.7107 5.815 14.4184 5.90172 14.1495L8.51327 6.32019C8.59867 6.05454 8.78607 5.83368 9.03427 5.70617C9.28246 5.57865 9.57114 5.55492 9.83683 5.64019L9.84527 5.64308L11.0779 6.05397Z",
    fill: "#0092D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.5496 14.28H8.96338V10.2148H9.5496V14.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.6343 12.2431C12.3043 11.8496 11.8997 11.5254 11.4438 11.2891V13.2002C11.8994 12.962 12.3039 12.6369 12.6343 12.2431Z",
    fill: "#E43D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.3975 8.49697L12.9575 6.68164C13.6415 7.42758 14.0528 8.38313 14.1244 9.39265C14.196 10.4022 13.9236 11.4062 13.3517 12.2412C13.9097 13.0489 14.1866 14.0175 14.14 14.9981C14.0933 15.9786 13.7256 16.9166 13.0935 17.6676L15.1357 18.3496C15.2676 18.393 15.4066 18.4099 15.545 18.3994C15.6834 18.3889 15.8183 18.3513 15.9422 18.2887C16.066 18.2261 16.1762 18.1396 16.2667 18.0344C16.3571 17.9291 16.4258 17.8071 16.4691 17.6752V17.6723L19.0806 9.84342C19.1674 9.57426 19.1443 9.28173 19.0163 9.02954C18.8884 8.77735 18.666 8.58593 18.3975 8.49697ZM16.9531 14.2696H16.2197L14.7086 12.2412L16.2446 10.2079H16.9891L15.4477 12.2412L16.9531 14.2696Z",
    fill: "#004B9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbk);
export default __webpack_public_path__ + "static/media/ibk.c40085d2820c02bf8eccae11ec054223.svg";
export { ForwardRef as ReactComponent };